<span class="cf-dlg-section__label">Reparto automático de gastos</span>

<app-loading-state *ngIf="loading" [compact]="true" message="Cargando reparto…"></app-loading-state>

<div class="cad-error" *ngIf="!loading && loadError">
  <span>No se pudo cargar el reparto automático.</span>
  <button mat-stroked-button type="button" (click)="retry()"><mat-icon>refresh</mat-icon> Reintentar</button>
</div>

<div class="cad" *ngIf="!loading && !loadError">
  <mat-slide-toggle [(ngModel)]="enabled" [ngModelOptions]="{standalone: true}" (change)="onToggle()" color="primary">
    Aplicar reparto automático en los gastos de este proveedor
  </mat-slide-toggle>
  <p class="cad-hint">
    En el formulario de gasto, un botón generará una línea por proyecto y financiación con el reparto de aquí.
    El % por proyecto es el ya guardado en «Reparto de gastos por proyecto».
  </p>

  <ng-container *ngIf="enabled">
    <div class="cad-warn" *ngIf="!usedRows.length">Este proveedor aún no tiene reparto por proyecto guardado.</div>

    <div class="cad-project" *ngFor="let row of usedRows">
      <div class="cad-project__head">
        <span class="cad-project__name">{{ row.projectName }}</span>
        <small>{{ row.value | number:'1.0-2' }} {{ row.mode === 'percentage' ? '%' : 'h' }}</small>
      </div>
      <div class="cad-warn" *ngIf="!row.grants.length">Este proyecto no tiene financiaciones: añade una para poder repartir el gasto.</div>
      <div class="cad-grant" *ngFor="let grant of row.grants">
        <span>{{ grant.provider || 'Financiación' }} <small>· {{ grant.amount | number:'1.2-2' }} €</small></span>
        <mat-form-field appearance="outline" class="cad-grant__value">
          <mat-label>%</mat-label>
          <input matInput type="number" min="0" max="100" [(ngModel)]="grant.percent" [ngModelOptions]="{standalone: true}">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
      <div class="cad-total" *ngIf="row.grants.length" [class.cad-total--bad]="grantsTotal(row) !== 100">
        Total financiaciones: {{ grantsTotal(row) | number:'1.0-2' }} %
      </div>
    </div>
  </ng-container>

  <div class="cad-warn" *ngIf="saveError">{{ saveError }}</div>

  <div class="cad-actions">
    <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving">
      <mat-icon>save</mat-icon> Guardar reparto automático
    </button>
  </div>
</div>
